import { Injectable } from '@angular/core';

// Import services:
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioCertificadoOcupacionalService {

  constructor( private requestUrl : ReportesRequestService ) { }

  public async getResponseCertificadoOcupacional( objetoCertificado : CertificadoServiceEntity ) {

    try {

      let response = await this.requestUrl.getRequest(
        'certificado/certificado-ocupacional',
        [ objetoCertificado.codigoBaseDatos, { "ln_id_trtmnto_asistn" : objetoCertificado.id } ]
      );

      if( response != null ) {
        return response;
      } else {
        return null;
      }

    } catch ( exception ) {
      console.log( "Servico Certificado Ocupacional Exception:\n" + exception );
    }

  }

  public async getResponseCertificadoOcupacionalPreguntas( objetoCertificado : CertificadoServiceEntity ) {

    try {

      let response = await this.requestUrl.getRequest(
        'certificado/certificado-ocupacional-preguntas',
        [ objetoCertificado.codigoBaseDatos, { "id_trtmnto_asstncl" : objetoCertificado.id } ]
      );

      if(response != null) {
        return response;
      } else {
        return null;
      }

    } catch( exception ) {
      console.log( "Servico Certificado Ocupacional Preguntas Exception:\n" + exception );
    }

  }

}

export interface CertificadoServiceEntity {
  codigoBaseDatos : string,
  id : string
}

export interface CertificadoPreguntasEntity {
  conceptoMedico : string,
  tipoValoracion : string,
  cumplimientoValoracion : string[],
  conclusionesOcupacionales : string,
  conductasOcupacionales : string[],
  recomendaciones : string[],
  profesion : string
}

export interface CertificadoDatosEntity {
  barrio : string,
  ciudad : string,
  descripcionMedico : string,
  direccion : string,
  empresa: string,
  fechaNacimiento : Date,
  fechaAtencion : Date,
  medicoAtencion : string,
  nit : string,
  nombre : string,
  numeroIdentificacion : string,
  registroMedico : string,
  sector : string,
  sexo : string,
  tipoIdentificacion : string,
  cargo : string
}